import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import IndexReport from './indexReport';
import GeneralReport from '../reporting';


const IndexsReportModel = () => {
 
  return (
    <>
     <GeneralReport endpoint="/indexes"/>
    </>
  );
};
export default IndexsReportModel;